import * as React from "react";

import { PraDto } from "core/backend/data";
import TDatetime from "components/TDatetime";

interface OwnProps {
    dto: PraDto;
    left: number;
}

const Row = ({ dto, left }: OwnProps) =>
    <tr>
        <TDatetime rowSpan={1} date={new Date(dto.dateTimeUtc)} left={left} />
        {(dto.reason ?? "") != ""
            ? <td colSpan={4} style={{ textAlign: "left" }}>{dto.reason}</td>
            : <>
                <td>{dto.name}{dto.reason}</td>
                <td>{dto.tso}</td>
                <td className="lineLeft">{dto.baseline}</td>
                <td>{dto.afterNrao}</td>
            </>
        }
    </tr>;

export default Row;